import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { TruthSection } from '../components/TruthSection';
import { SolutionSection } from '../components/SolutionSection';
import { ProductDetails } from '../components/ProductDetails';
import { WhoItsFor } from '../components/WhoItsFor';
import { CTASection } from '../components/CTASection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="w-full min-h-screen" data-id="element-252">
      <Hero data-id="element-253" />
      <ProblemSection data-id="element-254" />
      <TruthSection data-id="element-255" />
      <SolutionSection data-id="element-256" />
      <ProductDetails data-id="element-257" />
      <WhoItsFor data-id="element-258" />
      <CTASection data-id="element-259" />
      <FAQSection data-id="element-260" />
      <Footer data-id="element-261" />
    </main>;
}